// extracted by mini-css-extract-plugin
module.exports = {"header":"Main_header__2Qx-5","tabs":"Main_tabs__xqL3h","tab":"Main_tab__3Xc6i","link":"Main_link__1e7al","activeLink":"Main_activeLink__1d8aF"};